<template>
  <div 
    v-if="isLoaded"
    class="sm-customer"
  >
    <customer-top />
    <customer-main />
  </div>
  <sm-spinner
    v-else
    :show="true"
  />
</template>

<script>
import Upper from '@/views/admin/pages/customer/Upper.vue';
import Main from '@/views/admin/pages/customer/Main.vue';
import { mapActions } from 'vuex';
import Spinner from '@/components/Spinner'

export default {
  name: 'account',
  components: {
    'customer-top': Upper,
    'customer-main': Main,
    'sm-spinner': Spinner
  },
  data() {
    return {
      isLoaded: false
    };
  },
  created() {
    if (!this.$route.params.id)
      this.$router.push('../customers');
    
    this.getCustomer(this.$route.params.id)
      .then(res => {
        if (!res)
          this.$router.push('../customers');
        
        this.isLoaded = true;
      })
      .catch(e => {
        this.$router.push('../customers');
      })
  },
  computed: {

  },
  methods: {
    ...mapActions({
      getCustomer: 'customers/getCustomer'
    })
  }
}
</script>

<style lang="scss">
  
</style>
